export const formatToMexicoDateTime = (isoString: string): string => {
  const date = new Date(isoString);

  return new Intl.DateTimeFormat('es-MX', {
    timeZone: 'America/Mexico_City',
    year: 'numeric',
    month: 'long',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  }).format(date);
};


export const formatToMexicanPesos = (amount: string) => {
  // Aseguramos que la cantidad sea un número
  const numericAmount = parseFloat(amount);

  if (isNaN(numericAmount)) {
    // Si no es un número válido, retornamos un mensaje o el valor original
    return 'Cantidad no válida';
  }

  // Creamos una instancia de Intl.NumberFormat
  const formatter = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN', // Código de divisa para Pesos Mexicanos
    minimumFractionDigits: 2, // Muestra siempre dos decimales
  });

  // Formateamos y retornamos el resultado
  return formatter.format(numericAmount);
};